import { render, staticRenderFns } from "./HistoryListItem.vue?vue&type=template&id=90d636c6"
import script from "./HistoryListItem.vue?vue&type=script&lang=js"
export * from "./HistoryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports